/*
  Chefs Evolution – fereastra de căutare.
  - se deschide de la lupa din antet / bara de jos (în locul sertarului temei) și cu tasta „/”;
  - rezultatele apar pe măsură ce scrii (sugestiile Shopify), ca pe prima pagină, cu „+” (ce-acasa.js);
  - fără text: căutările recente (doar în acest browser), categoriile și produsele recomandate;
  - Enter sau „Vezi toate rezultatele” duce la pagina de rezultate (prin formularul obișnuit al magazinului).
*/
(function () {
  'use strict';
  if (window.__ceCautare) return;
  window.__ceCautare = true;

  var CHEIE = 'ce-cautari-recente';
  var el, text, continut, recente, listaRecente, jos, termenJos, sterge, anunt, formular;
  var ultimFocus = null, cerere = null, temporizare = null, golIncarcat = false, ultimulTermen = '';

  function citesteRecente() {
    try { var x = JSON.parse(localStorage.getItem(CHEIE) || '[]'); return Array.isArray(x) ? x.filter(function (s) { return typeof s === 'string'; }).slice(0, 6) : []; } catch (e) { return []; }
  }
  function salveazaRecent(t) {
    t = String(t || '').replace(/\s+/g, ' ').trim();
    if (t.length < 2) return;
    var x = citesteRecente().filter(function (s) { return s.toLowerCase() !== t.toLowerCase(); });
    x.unshift(t.slice(0, 60));
    try { localStorage.setItem(CHEIE, JSON.stringify(x.slice(0, 6))); } catch (e) { /* stocare indisponibilă */ }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function deseneazaRecente() {
    var x = citesteRecente();
    var arata = x.length && !text.value.trim();
    recente.hidden = !arata;
    if (!arata) return;
    listaRecente.innerHTML = x.map(function (s) {
      return '<button type="button" class="ce-cautare__cip ce-cautare__cip--recent" data-ce-termen="' + esc(s) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7v5l3 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2"/></svg><span>' + esc(s) + '</span></button>';
    }).join('');
  }

  function incarcaAcasa() {
    if (window.__ceAcasa) return;
    var src = el.getAttribute('data-acasa-js');
    if (!src || document.querySelector('script[data-ce-acasa]')) return;
    var s = document.createElement('script');
    s.src = src; s.defer = true; s.setAttribute('data-ce-acasa', '');
    document.head.appendChild(s);
  }

  function puneRezultate(html, termen) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var rez = d.querySelector('[data-ce-rezultate]');
    if (!rez) return;
    continut.innerHTML = rez.outerHTML;
    continut.setAttribute('aria-busy', 'false');
    var areTermen = Boolean(termen);
    jos.hidden = !areTermen;
    if (areTermen) {
      termenJos.textContent = termen;
      var n = Number(rez.getAttribute('data-numar') || 0);
      anunt.textContent = n ? (n === 1 ? 'Un produs găsit' : n + ' produse găsite') : 'Niciun produs găsit';
    } else {
      anunt.textContent = '';
    }
  }

  function cauta(termen) {
    termen = termen.replace(/\s+/g, ' ').trim();
    if (cerere) cerere.abort();
    cerere = 'AbortController' in window ? new AbortController() : null;
    var url;
    if (!termen) {
      if (golIncarcat && !ultimulTermen) return;
      url = el.getAttribute('data-url-gol') + '?section_id=ce-cautare-rezultate';
    } else {
      url = el.getAttribute('data-url-sugestii') + '?q=' + encodeURIComponent(termen) +
        '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=' + encodeURIComponent(el.getAttribute('data-indisponibile') || 'last') +
        '&section_id=ce-cautare-rezultate';
    }
    ultimulTermen = termen;
    continut.setAttribute('aria-busy', 'true');
    el.classList.add('is-cauta');
    fetch(url, cerere ? { signal: cerere.signal } : undefined).then(function (r) {
      if (!r.ok) throw r;
      return r.text();
    }).then(function (html) {
      if (termen !== ultimulTermen) return;
      el.classList.remove('is-cauta');
      if (!termen) golIncarcat = true;
      puneRezultate(html, termen);
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      el.classList.remove('is-cauta');
      continut.setAttribute('aria-busy', 'false');
      if (termen) {
        continut.innerHTML = '<div class="ce-cautare__gol"><p><b>Căutarea nu a mers acum.</b></p><p>Apasă Enter ca să vezi rezultatele pe pagină.</p></div>';
        jos.hidden = false; termenJos.textContent = termen;
      }
    });
  }

  function laScriere() {
    var t = text.value;
    sterge.hidden = !t;
    deseneazaRecente();
    clearTimeout(temporizare);
    var curat = t.replace(/\s+/g, ' ').trim();
    if (curat.length === 1) return;
    temporizare = setTimeout(function () { cauta(curat); }, curat ? 220 : 0);
  }

  function deschide(valoare, declansator) {
    if (!el) return;
    ultimFocus = declansator || document.activeElement;
    incarcaAcasa();
    el.hidden = false;
    document.documentElement.classList.add('ce-cautare-deschisa');
    requestAnimationFrame(function () { el.classList.add('is-deschis'); });
    if (typeof valoare === 'string') text.value = valoare;
    sterge.hidden = !text.value;
    deseneazaRecente();
    if (text.value.trim().length > 1) cauta(text.value); else cauta('');
    setTimeout(function () { text.focus(); }, 30);
    document.addEventListener('keydown', taste, true);
  }
  function inchide() {
    if (!el || el.hidden) return;
    el.classList.remove('is-deschis');
    document.documentElement.classList.remove('ce-cautare-deschisa');
    document.removeEventListener('keydown', taste, true);
    setTimeout(function () { el.hidden = true; }, 180);
    if (ultimFocus && ultimFocus.focus) ultimFocus.focus();
  }
  function taste(e) {
    if (e.key === 'Escape') {
      if (document.querySelector('.ce-foaie')) return; // fereastra de mărimi se închide prima
      e.preventDefault(); inchide(); return;
    }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var prim = f[0], ultim = f[f.length - 1];
    if (e.shiftKey && document.activeElement === prim) { e.preventDefault(); ultim.focus(); }
    else if (!e.shiftKey && document.activeElement === ultim) { e.preventDefault(); prim.focus(); }
  }
  function trimite() {
    salveazaRecent(text.value);
    if (formular.requestSubmit) formular.requestSubmit(); else formular.submit();
  }

  // lupa temei: antet, bara de jos, meniul de pe telefon
  function esteLupa(t) {
    var a = t.closest && t.closest('[data-drawer-options]');
    return a && /t4s-search-hidden/.test(a.getAttribute('data-drawer-options') || '') ? a : null;
  }
  window.addEventListener('click', function (e) {
    if (!el) return;
    var a = esteLupa(e.target);
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    deschide(undefined, a);
  }, true);
  // câmpul de căutare din antet (unde tema îl afișează direct): îl preluăm la focus
  document.addEventListener('focusin', function (e) {
    if (!el || !el.hidden) return;
    var i = e.target;
    if (!i.matches || !i.matches('[data-predictive-search] input[name="q"], [data-predictive-search] [data-input-search]')) return;
    var v = i.value;
    i.blur();
    deschide(v, i);
  });
  document.addEventListener('keydown', function (e) {
    if (!el || !el.hidden || e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    e.preventDefault(); deschide();
  });

  function porneste() {
    el = document.querySelector('[data-ce-cautare]');
    if (!el) return;
    text = el.querySelector('[data-ce-cautare-text]');
    continut = el.querySelector('[data-ce-cautare-continut]');
    recente = el.querySelector('[data-ce-recente]');
    listaRecente = el.querySelector('[data-ce-recente-lista]');
    jos = el.querySelector('[data-ce-cautare-jos]');
    termenJos = el.querySelector('[data-ce-cautare-termen]');
    sterge = el.querySelector('[data-ce-cautare-sterge]');
    anunt = el.querySelector('[data-ce-cautare-anunt]');
    formular = el.querySelector('form');

    text.addEventListener('input', laScriere);
    // se salvează la Enter, înainte ca regula magazinului să rescrie textul („title:…”) la trimitere
    text.addEventListener('keydown', function (e) { if (e.key === 'Enter') salveazaRecent(text.value); });
    formular.addEventListener('submit', function (e) { if (!text.value.trim()) e.preventDefault(); });
    sterge.addEventListener('click', function () { text.value = ''; laScriere(); text.focus(); });
    el.querySelector('[data-ce-cautare-toate]').addEventListener('click', trimite);
    el.querySelector('[data-ce-recente-sterge]').addEventListener('click', function () {
      try { localStorage.removeItem(CHEIE); } catch (e) { /* nimic */ }
      deseneazaRecente(); text.focus();
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ce-cautare-inchide]')) { inchide(); return; }
      var t = e.target.closest('[data-ce-termen]');
      if (t) {
        e.preventDefault();
        text.value = t.getAttribute('data-ce-termen');
        laScriere();
        text.focus();
        return;
      }
      // a ales un produs sau o categorie: păstrăm căutarea în „recente”
      if (e.target.closest('a[href]') && text.value.trim()) salveazaRecent(text.value);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste); else porneste();
})();
